import { render, staticRenderFns } from "./customer-v2.vue?vue&type=template&id=6dc24506&"
import script from "./customer-v2.vue?vue&type=script&lang=js&"
export * from "./customer-v2.vue?vue&type=script&lang=js&"
import style0 from "vue-slim-tabs/themes/default.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports